import React, { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";

import classNames from "classnames/bind";
import styles from "./CartItem.module.scss";
import QuantityControl from "./QuantityControl";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import useDebounce from "../../hooks/useDebounce";
import useCheckoutProductStore from "../../stores/CheckoutProduct/useCheckoutProductStore";
import Images from "../../asset/images";
import { translateProductName } from "../../utils/translateProductName";

const cx = classNames.bind(styles);

const CartItem = ({ item, onUpdateQuantity, onRemove, className }) => {
  const { toggleSelectCartItem, isCartItemSelected } =
    useCheckoutProductStore();

  // State để hiển thị quantity ngay lập tức (UI responsive)
  const [displayQty, setDisplayQty] = useState(item.quantity);
  const { formatPrice } = useLanguageStore();

  // Debounce quantity để gọi API
  const debouncedQuantity = useDebounce(displayQty, 500);

  // Đồng bộ displayQty khi prop item.quantity thay đổi từ ngoài (sau khi API thành công)
  useEffect(() => {
    setDisplayQty(item.quantity);
  }, [item.quantity]);

  // Chỉ gọi API khi debouncedQuantity khác với item.quantity ban đầu
  useEffect(() => {
    const cartItemKey = item.local_key || item.cart_item_key;
    if (debouncedQuantity !== item.quantity) {
      if (debouncedQuantity === 0) {
        // Nếu quantity = 0, xóa item
        onRemove(cartItemKey);
      } else {
        // Ngược lại, cập nhật quantity
        onUpdateQuantity(cartItemKey, debouncedQuantity);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuantity]);

  const handleIncrease = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDisplayQty((prev) => prev + 1);
  };

  const handleDecrease = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDisplayQty((prev) => {
      const newQty = prev - 1;
      // Nếu quantity = 0, sẽ trigger useEffect để xóa item
      return newQty <= 0 ? 0 : newQty;
    });
  };

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove(item.local_key || item.cart_item_key);
  };

  return (
    <div
      className={cx(
        "cart-item",
        { selected: isCartItemSelected(item.cart_item_key) },
        className
      )}
      onClick={() => toggleSelectCartItem(item)}
    >
      <div className={cx("cart-item__image")}>
        <img src={item.image || Images.ErrorImage} alt={item.name} loading="lazy"/>
      </div>
      <div className={cx("cart-item__details")}>
        <h3 className={cx("cart-item__name")}>{translateProductName(item.name)}</h3>
        <div className={cx("cart-item__option")}>
          <span>{item.selected || "null"}</span>
        </div>
        <p className={cx("cart-item__price")}>{formatPrice(item.price)}</p>
        <div className={cx("cart-item__controls")}>
          <QuantityControl
            quantity={displayQty}
            onIncrease={handleIncrease}
            onDecrease={handleDecrease}
          />
        </div>
      </div>
      <button className={cx("cart-item__remove")} onClick={handleRemove}>
        <Trash2 size={16} />
      </button>
    </div>
  );
};

export default CartItem;
